<template>
	<svg xmlns="http://www.w3.org/2000/svg" version="1.2" viewBox="31.49 29.69 53.34 53.63">
		<defs>
			<clipPath clipPathUnits="userSpaceOnUse" id="cp1">
				<path d="m0 0h113v113h-113z" />
			</clipPath>
		</defs>
		<g id="Page 1" clip-path="url(#cp1)">
			<path
				id="Path 3"
				class="s0"
				d="m60.98 55.73v27.59c-0.85-0.63-1.54-1.05-2.14-1.57-5.41-4.8-10.78-9.65-16.25-14.39-0.77-0.67-1.98-1.09-3.02-1.15-2.62-0.17-5.26-0.06-8.07-0.06q-0.01-5.19 0-10.16"
			/>
			<path
				id="Path 4"
				fill-rule="evenodd"
				class="s0"
				d="m31.5 57.02q-0.01-4.98 0-10.17c2.81 0 5.45 0.11 8.07-0.05 1.04-0.06 2.25-0.49 3.02-1.16 5.47-4.73 10.84-9.59 16.25-14.38 0.6-0.53 1.29-0.95 2.14-1.57v27.59m23.86-0.52c-0.09 6.45-2.01 12.47-6.17 17.71-0.72 0.9-1.52 2.03-2.8 1.08-1.36-1.01-0.8-2.18 0.08-3.34 7.48-9.85 7.48-21.8-0.01-31.49-0.9-1.15-1.43-2.3-0.08-3.33 1.31-0.98 2.08 0.18 2.79 1.07 4.21 5.3 6.14 11.38 6.19 18.3z"
			/>
			<path
				id="Path 5"
				class="s0"
				d="m78.21 56.8c-0.1 4.49-1.41 8.85-4.44 12.63-0.7 0.87-1.5 1.76-2.66 0.81-1.09-0.89-0.94-2.01-0.07-3.02 5.14-5.91 5.12-15.66-0.03-21.54-0.87-1-0.98-2.13 0.15-3 1.21-0.95 1.95 0.05 2.64 0.88 2.73 3.25 4.41 8.17 4.41 13.24z"
			/>
			<path
				id="Path 6"
				class="s0"
				d="m70.51 56.67c-0.06 2.72-0.86 5.37-2.69 7.66-0.43 0.52-0.91 1.07-1.62 0.49-0.66-0.54-0.56-1.22-0.04-1.83 3.11-3.59 3.1-9.5-0.02-13.06-0.53-0.61-0.59-1.29 0.09-1.82 0.74-0.57 1.18 0.04 1.61 0.54 1.65 1.96 2.66 4.95 2.67 8.02z"
			/>
		</g>
	</svg>
</template>

<style>
	.s0 {
		fill: #ffffff;
	}
</style>
